exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ReactTable .review-incoming-applications-sub-grid {\n  margin-top: 0px !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;\n  border-left: none;\n  border-right: none;\n}\n.ReactTable .review-incoming-applications-sub-grid .review-incoming-applications-sub-grid-header {\n  color: white !important;\n}\n.ReactTable .review-incoming-applications-sub-grid .review-incoming-applications-sub-grid-header .rt-th {\n  background: #3b6b88 !important;\n}\n.rvia-modal.ui.modal .scrolling.content {\n  max-height: calc(85vh) !important;\n}\n.rvia-modal.ui.modal .ReactTable .rt-tr-group :not(.no-hover):hover .rt-td {\n  background: inherit;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/reviewincomingapplications/reviewincomingapplications.less
// module id = 2990
// module chunks = 0